
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta } from "/app/pages/admin.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta } from "/app/pages/logout.vue?macro=true";
import { default as othersjp_452SqdsTANQkAyjYrRR79FAy3tR_45iVh90wr_4YmvYkMeta } from "/app/pages/others.vue?macro=true";
import { default as callbackpP4QV_45aDBAaDodrISXkTgcnAismuCak5ttSJOC_45p1sMMeta } from "/app/pages/callback.vue?macro=true";
import { default as _91uuid_93jhPUPa5B0_jRdUT144fojTUVrNbDQ9KLFHL2SuVBevwMeta } from "/app/pages/test/[uuid].vue?macro=true";
import { default as indextglabt4oWDdDw1EekcNXKRyD0pdmc6ixY0qyLwc5jpEMeta } from "/app/pages/teacher/index.vue?macro=true";
import { default as _91uuid_93aYh1Le4xEJcOIU1PmukmghQ2P7evkq_45j0lYBRn9_OhQMeta } from "/app/pages/concept/[uuid].vue?macro=true";
import { default as indexru1iidRne1Cvejv6WJJ7PxRWVf2hcuf05pXUmcSdP_45UMeta } from "/app/pages/concepts/index.vue?macro=true";
import { default as trackx2cmCGomIS3krW82iOy73K9v9tB6Qg_4teIgAFZ3GUQMeta } from "/app/pages/concepts/track.vue?macro=true";
import { default as courseGr4lAQgr28Grk9MH2QB1dB_4591p_45RAoLNZPiDgsRDAtYMeta } from "/app/pages/concepts/course.vue?macro=true";
import { default as quartileP7kBfv26X_vHIVDjEPEeFHJBDEwrzXYh4HvpbsEhbcAMeta } from "/app/pages/concepts/quartile.vue?macro=true";
import { default as _91uuid_93QTVRxJcGjMlELmvVQAhh8LPgxb2_45ap8jEjx_45M8_6fHoMeta } from "/app/pages/teacher/concept/[uuid].vue?macro=true";
import { default as deleted_45conceptsfvEvZmTOI5XmJzPZsQMGZ6xJC9h1bESGayvlgvLd4_45MMeta } from "/app/pages/teacher/deleted-concepts.vue?macro=true";
import { default as editPpegnAFcugeaMq1FYijHHWfdud0ofpvV3vAAlNmI9f0Meta } from "/app/pages/teacher/test-questions/[uuid]/edit.vue?macro=true";
import { default as indexS5_45qR4_45LVhYlaV_CQUFxoqXhmgHiSdEccnwlpFCqTVsMeta } from "/app/pages/teacher/test-questions/[uuid]/index.vue?macro=true";
export default [
  {
    name: "admin___en",
    path: "/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/pages/admin.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "logout___en",
    path: "/logout",
    meta: logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta || {},
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "others___en",
    path: "/others",
    component: () => import("/app/pages/others.vue")
  },
  {
    name: "callback___en",
    path: "/callback",
    meta: callbackpP4QV_45aDBAaDodrISXkTgcnAismuCak5ttSJOC_45p1sMMeta || {},
    component: () => import("/app/pages/callback.vue")
  },
  {
    name: "test-uuid___en",
    path: "/test/:uuid()",
    component: () => import("/app/pages/test/[uuid].vue")
  },
  {
    name: "teacher___en",
    path: "/teacher",
    meta: {"middleware":["auth","teacher"]},
    component: () => import("/app/pages/teacher/index.vue")
  },
  {
    name: "concept-uuid___en",
    path: "/concept/:uuid()",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/concept/[uuid].vue")
  },
  {
    name: "concepts___en",
    path: "/concepts",
    component: () => import("/app/pages/concepts/index.vue")
  },
  {
    name: "concepts-track___en",
    path: "/concepts/track",
    component: () => import("/app/pages/concepts/track.vue")
  },
  {
    name: "concepts-course___en",
    path: "/concepts/course",
    component: () => import("/app/pages/concepts/course.vue")
  },
  {
    name: "concepts-quartile___en",
    path: "/concepts/quartile",
    component: () => import("/app/pages/concepts/quartile.vue")
  },
  {
    name: "teacher-concept-uuid___en",
    path: "/teacher/concept/:uuid()",
    meta: {"middleware":["auth","teacher"]},
    component: () => import("/app/pages/teacher/concept/[uuid].vue")
  },
  {
    name: "teacher-deleted-concepts___en",
    path: "/teacher/deleted-concepts",
    meta: {"middleware":["auth","teacher"]},
    component: () => import("/app/pages/teacher/deleted-concepts.vue")
  },
  {
    name: "teacher-test-questions-uuid-edit___en",
    path: "/teacher/test-questions/:uuid()/edit",
    meta: {"middleware":["auth","teacher"]},
    component: () => import("/app/pages/teacher/test-questions/[uuid]/edit.vue")
  },
  {
    name: "teacher-test-questions-uuid___en",
    path: "/teacher/test-questions/:uuid()",
    meta: {"middleware":["auth","teacher"]},
    component: () => import("/app/pages/teacher/test-questions/[uuid]/index.vue")
  }
]